var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyForm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.59961 11.3963C6.59961 8.67028 6.59961 7.30728 7.44261 6.46028C8.28661 5.61328 9.64361 5.61328 12.3596 5.61328H15.2396C17.9546 5.61328 19.3126 5.61328 20.1556 6.46028C20.9996 7.30728 20.9996 8.67028 20.9996 11.3963V16.2163C20.9996 18.9423 20.9996 20.3053 20.1556 21.1523C19.3126 21.9993 17.9546 21.9993 15.2396 21.9993H12.3596C9.64361 21.9993 8.28661 21.9993 7.44261 21.1523C6.59861 20.3053 6.59961 18.9423 6.59961 16.2163V11.3963Z",
    fill: "#6B7280"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M4.172 3.172C3 4.343 3 6.229 3 10V12C3 15.771 3 17.657 4.172 18.828C4.789 19.446 5.605 19.738 6.792 19.876C6.6 19.036 6.6 17.88 6.6 16.216V11.397C6.6 8.671 6.6 7.308 7.443 6.461C8.287 5.614 9.644 5.614 12.36 5.614H15.24C16.892 5.614 18.04 5.614 18.878 5.804C18.74 4.611 18.448 3.792 17.828 3.172C16.657 2 14.771 2 11 2C7.229 2 5.343 2 4.172 3.172Z",
    fill: "#6B7280"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyForm);
export default __webpack_public_path__ + "static/media/copy-form.c8bd55f08d5ec5e750bac6af8a23ca7c.svg";
export { ForwardRef as ReactComponent };